import { render } from "./Alphabet.vue?vue&type=template&id=4d482c46&ts=true"
import script from "./Alphabet.vue?vue&type=script&lang=ts"
export * from "./Alphabet.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__